import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
    executeConsumerGet,
    profileData,
    profileGetError,
} from '../../../store/actions/profileActions';
import { loyaltyReset } from '../../../store/actions/loyaltyActions';
import { otpPhoneReset } from '../../../store/actions/otpPhoneActions';

import TabsBox from './TabsBox';
import { Stack, Box } from '@mui/material';

import { useMessages } from '../../../hooks/useMessages';
import { usePageTitle } from '../../../hooks/usePageTitle';
import CircularProgress from '../../common/CircularProgress';
import { dialogShow, dialogClose } from '../../../store/actions/dialogActions';

const ConsumerPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const { L } = useMessages();
    usePageTitle(L.consumerpage_title);

    const model = useSelector((state) => state.profile);
    const { data, errorGet } = model;
    const hasConsumer = !!data;

    useEffect(() => {
        dispatch(executeConsumerGet(id));
        return () => {
            dispatch(profileData(null));
            dispatch(loyaltyReset());
            dispatch(otpPhoneReset());
        };
    }, [dispatch, id]);

    useEffect(() => {
        if (errorGet !== null) {
            dispatch(
                dialogShow(
                    (L) => L.dialog_get_consumer_error_title,
                    (L) => L.dialog_get_consumer_error_text,
                    () => {
                        dispatch(profileGetError(null));
                        dispatch(executeConsumerGet(id));
                        dispatch(dialogClose());
                    },
                    () => {
                        dispatch(profileGetError(null));
                        navigate('/search');
                    }
                )
            );
        }
    }, [errorGet, id, dispatch, navigate]);

    return (
        <Stack component="main" role="main" alignItems="center">
            {!errorGet &&
                (hasConsumer ? (
                    <TabsBox model={model} />
                ) : (
                    <Box pt={16}>
                        <CircularProgress />
                    </Box>
                ))}
        </Stack>
    );
};

export default ConsumerPage;
